import z, { literal, preprocess } from 'zod';

import { requiresActivationConstraintWithLimitsSchema } from '@occc/feat-constraints/schemas';

import { SpendBonusSchema } from './spend-bonus.schema';

import { AwardCountWithTransactionFrequencyOnlySchema } from '../award-count.schema';
import { AwardPointsVariantSchema, AwardVouchersVariantSchema } from '../award.schema';
import { BaseOfferConfigurationSchema } from '../base-offer.schema';

import { OfferType } from '../../types';

const SpendBonusOfferBaseSchema = BaseOfferConfigurationSchema.extend({
  offerType: literal(OfferType.SpendBonus),
  spendBonus: preprocess((data) => data ?? {}, SpendBonusSchema),
  awardCount: AwardCountWithTransactionFrequencyOnlySchema,
  activation: requiresActivationConstraintWithLimitsSchema,
});

export const SpendBonusOfferSchema = z.discriminatedUnion('awardType', [
  SpendBonusOfferBaseSchema.merge(AwardPointsVariantSchema),
  SpendBonusOfferBaseSchema.merge(AwardVouchersVariantSchema),
]);
